<template>
  <div>
    <v-row>
      <v-col>
        <h2 v-if="$route.params.id != undefined">{{ $t('jobs.edit_job') }}</h2>
        <h2 v-else>{{ $t('jobs.new_job') }}</h2>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-col xl="6" lg="6" md="6" sm="6" cols="12">
        <v-text-field :label="$t('jobs.job_title')" v-model="job_data.title"></v-text-field>
      </v-col>
      <v-col xl="6" lg="6" md="6" sm="6" cols="12">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="select_publish_date" persistent width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="select_publish_date"
              :label="$t('jobs.publish_date')"
              :prepend-icon="calendar_icon"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="select_publish_date" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal = false"> {{ $t('general.cancel') }} </v-btn>
            <v-btn text color="primary" @click="$refs.dialog.save(select_publish_date)">
              {{ $t('general.ok') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-col>
        <h3>{{ $t('jobs.requirement') }}</h3>
      </v-col>
    </v-row>
    <QuillEditor class="mt-4" editorID="editor1" :html.sync="job_data.requirement"></QuillEditor>
    <v-row class="mt-8">
      <v-col>
        <v-btn v-if="$route.params.id != undefined" color="success" depressed @click="updateJob" :loading="load_table">
          {{ $t('general.save') }}
        </v-btn>
        <v-btn v-else color="success" depressed @click="addNewJob" :loading="loading">
          {{ $t('general.add') }}
        </v-btn>
      </v-col>
    </v-row>
    <SnackBar :text="snack_bar_text" :snackbar="snack_bar_open" v-on:close="updateSnackBar" />
  </div>
</template>

<script>
import { mdiCalendar } from '@mdi/js'
import { getData, postData } from '@/api'
import QuillEditor from '@/components/QuillEditor'
import SnackBar from '@/components/SnackBar'
import Dialog from '@/components/Dialog'
import { globalFunc } from '@/global'

export default {
  name: 'JobDetail',
  mixins: [globalFunc],
  components: { QuillEditor, SnackBar, Dialog },
  data: () => ({
    calendar_icon: mdiCalendar,
    modal: false,
    snack_bar_text: '',
    snack_bar_open: false,
    job_data: {
      title: '',
      requirement: '',
      publish_date: '',
    },
    select_publish_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substring(0, 10),
    loading: false,
  }),
  methods: {
    async initializeJob() {
      if (!this.loading) {
        this.loading = true

        let error = true
        try {
          let params = new URLSearchParams()

          params.set(
            'get_single_data_by_data_type_and_id',
            JSON.stringify({
              id: this.$route.params.id,
              data_type: 'job_data',
            }),
          )

          let result = await getData(params)
          if (globalFunc.DataValid(result)) {
            this.select_publish_date = result.publish_date

            Object.assign(this.job_data, result)
            error = false
          }
        } catch (error) {
          globalFunc.log(error)
        }

        if (error) {
          this.snack_bar_text = this.$t('instruction.data_not_found')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'Jobs' })
          }, 2000)
        } else {
          this.loading = false
        }
      }
    },
    async addNewJob() {
      if (!this.loading) {
        this.loading = true
        this.job_data.publish_date = this.select_publish_date

        if (!globalFunc.DataValid(this.job_data.title)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('jobs.job_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.job_data.requirement)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('jobs.requirement')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        try {
          let params = new URLSearchParams()

          params.set('add_job', JSON.stringify(this.job_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.create_success')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'Jobs' })
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.create_fail')
          this.snack_bar_open = true
          this.loading = false
          globalFunc.log(error)
        }
      }
    },
    async updateJob() {
      if (!this.loading) {
        this.loading = true

        this.job_data.publish_date = this.select_publish_date

        if (!globalFunc.DataValid(this.job_data.title)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('jobs.job_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.job_data.requirement)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('jobs.requirement')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        try {
          let params = new URLSearchParams()

          params.set('update_job', JSON.stringify(this.job_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.update_success')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'Jobs' })
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.update_fail')
          this.snack_bar_open = true
          this.loading = false
          globalFunc.log(error)
        }
      }
    },
    updateSnackBar(status) {
      this.snack_bar_open = status
    },
  },
  created() {
    if (this.$route.params.id != undefined) {
      this.initializeJob()
    }
  },
}
</script>
